import { useState } from "react";
import { api } from "@/lib/api";

/** Tester suggestion box — anonymous-friendly, shown across academy pages. */
export default function AcademySuggest({ page }) {
  const [open, setOpen] = useState(false);
  const [text, setText] = useState("");
  const [email, setEmail] = useState("");
  const [msg, setMsg] = useState("");

  async function submit(e) {
    e.preventDefault();
    try {
      const res = await api.post("/academy/feedback", { text, page, email }).catch(
        (err) => { throw new Error(err.response?.data?.detail || "Failed to send."); },
      );
      setMsg(`Saved — reference ${res.data.reference}. Thank you!`);
      setText("");
    } catch (err) {
      setMsg(err.message);
    }
  }

  return (
    <div style={{ maxWidth: 640, margin: "26px auto 0" }} data-testid="academy-suggest">
      {!open ? (
        <button className="textbutton" data-testid="academy-suggest-open" onClick={() => setOpen(true)}>
          💬 Have a suggestion for the class? Tell us →
        </button>
      ) : (
        <form onSubmit={submit} className="academy-exam">
          <h3>Suggest an improvement</h3>
          <textarea rows={4} maxLength={2000} required value={text} onChange={(e) => setText(e.target.value)}
            data-testid="academy-suggest-text" placeholder="What should the class cover, add or explain better?" style={{ width: "100%" }} />
          <input value={email} onChange={(e) => setEmail(e.target.value)} maxLength={254} placeholder="Your email (optional)"
            data-testid="academy-suggest-email" style={{ width: "100%", marginTop: 8 }} />
          <div style={{ display: "flex", gap: 10, marginTop: 10, alignItems: "center" }}>
            <button className="btn small lime" data-testid="academy-suggest-submit">Send suggestion</button>
            <button type="button" className="textbutton" onClick={() => setOpen(false)}>Close</button>
            {msg && <span className="micro">{msg}</span>}
          </div>
        </form>
      )}
    </div>
  );
}
